// extracted by css-extract-rspack-plugin
export default {"details":"D46Hu","tags":"IQ874"};